import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { Link as RLink } from 'react-router-dom'

import OpenInNewIcon from '@material-ui/icons/OpenInNew';

const styles = theme => ({
  root: {
    color: '#42A5F5',
    textDecoration: "none",
    fontSize: 14
  },
  iconLink: {
    display: "flex",
    alignItems: "center"
  },
  button: {
    border: 0,
    background: "transparent",
    padding: "12px 0px",
    outline: "none",
    cursor: "pointer"
  }
});

const Link = ({ url, text, target, classes, isButton = false, onClick }) => {
  if(isButton)
    return (
      <button type="button" className={classes.root + " " + classes.button} onClick={onClick ? onClick : e => console.log("Link clicked!")}>{text}</button>
    );
  else
    return (
      <RLink target={target} className={classes.root + " " + (target === "_blank" ? classes.iconLink : "")} to={url}>{target === "_blank" ? <OpenInNewIcon/> : ""} {text}</RLink>
    );
}

Link.propTypes = {
  url: PropTypes.string,
  text: PropTypes.string.isRequired,
  classes: PropTypes.object.isRequired,
  target: PropTypes.string,
  isButton: PropTypes.bool,
  onClick: PropTypes.func
}

export default withStyles(styles)(Link)